import "./SteelAndMetalsCaseStudy.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Detailedcasestudy from "./sections/Detailedcasestudy";
import DetailedcasestudyCopy from "./sections/DetailedcasestudyCopy";
import Footer from "@/reusable_sections/Footer";
export default function SteelAndMetalsCaseStudyPage() {
  return <div>
      <Header />
      <Hero />
      <Detailedcasestudy />
      <DetailedcasestudyCopy />
      <Footer />
    </div>;
}